import { render, staticRenderFns } from "./ImageCropper.vue?vue&type=template&id=1f4a1e2c&scoped=true"
import script from "./ImageCropper.vue?vue&type=script&lang=js"
export * from "./ImageCropper.vue?vue&type=script&lang=js"
import style0 from "./ImageCropper.vue?vue&type=style&index=0&id=1f4a1e2c&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1f4a1e2c",
  null
  
)

export default component.exports